import './switch.module.scss';
import MaterialSwitch from '@mui/material/Switch';
import { ChangeEvent, ReactNode } from 'react';
import FormGroup from '@mui/material/FormGroup';
import MaterialFormControlLabel from '@mui/material/FormControlLabel';

/* eslint-disable-next-line */
export interface SwitchProps {
  checked: boolean;
  // checkedIcon?: ReactNode,
  // classes?: object,
  color?: | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  // defaultChecked?: boolean,
  disabled?: boolean,
  // disableRipple?: boolean,
  // edge?:'end'| 'start'| false,
  // icon?: ReactNode,
  // id?: string,
  // inputProps?: object,
  // inputRef?: any,
  onChange?: (event: ChangeEvent, checked: boolean) => void,
  // required?: boolean,
  size?: 'medium' | 'small',
  sx?: any,
  value?: any,
  className?: string,
  label?: any
}

export function Switch(props: SwitchProps) {
  return (
    <MaterialSwitch
      disabled={props.disabled}
      checked={props.checked}
      onChange={props.onChange}
      color={props.color}
      value={props.value}
      sx={props.sx}
      className={props.className}
      size={props.size}
    />
  );
}

export function SwitchLabel(props: SwitchProps) {
  return (
    <FormGroup>
      <MaterialFormControlLabel
        control={<Switch {...props} />}
        label={props.label}
        sx={props.sx}
        className={props.className}
        disabled={props.disabled}
      />
    </FormGroup>
  );
}

export default Switch;